var _defs, _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon Station Home",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".i-homestation-1{fill:currentColor}.i-homestation-2,.i-homestation-4{fill:none}.i-homestation-2{stroke:currentColor;stroke-width:2px}.i-homestation-3{stroke:none}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "i-homestation-1",
    transform: "translate(4 3.682)",
    cx: 2,
    cy: 2,
    r: 2,
    "data-name": "Ellipse 1841"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "i-homestation-1",
    transform: "translate(1 9)",
    d: "M0 0h9.932v2H0z",
    "data-name": "Rechteck 135020"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "i-homestation-2",
    "data-name": "Rechteck 135019"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i-homestation-3",
    d: "M0 0h7a5 5 0 0 1 5 5v6a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i-homestation-4",
    d: "M2 1h5a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V2a1 1 0 0 1 1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStation);
export default __webpack_public_path__ + "static/media/homeStation.08641bd2552ba15c6c3ea8661aa21ab1.svg";
export { ForwardRef as ReactComponent };